
import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";
import { Table, Tooltip } from "antd";
import {
  showTotal,
  onShowSizeChange,
  itemRender,
} from "../_components/paginationfunction";
//import Data from "../assets/jsons/vendors";
import api from "../api/api"
import { useAuth } from "../context/AuthContext";
import { useTranslation } from 'react-i18next';
//import { fetchVendorIdSidebar } from "../biodata/Allbiodata";
const InvitePending = () => {

  const {user} = useAuth()

const { t } = useTranslation();
  const [menu, setMenu] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [error, setError] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  

  const fetchData = async (page = 1) => {
    //{loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }

    setLoadingForm(true)
    setError(null)


    try {

      //if(!user.token) return
      const response = await api.get("/invite/pending/", + `?page=${page}`);


      // Handle success based on status code
      if (response.status === 200) {
        if (Array.isArray(response.data.results)) {

          // if(response.data.length==0)
          // response.data.forEach(item => console.log(item));
          

          //the prop children is causing error on table
          const updatedData = response.data.results.map(({ children, ...rest }) => ({
            enfants: children, // Rename 'children' to 'enfants'
            ...rest,
          }));

          setData(updatedData)
          setNextPage(response.data.next);
          setPrevPage(response.data.previous);
          setCount(response.data.count);
        } else {
          console.error("Data is not an array:", response.data);
          setError(response.status)
        }

      } 

    } catch (error) {
      console.error("API Error:", error);

      if (error.response) {
        // The request was made and the server responded with a status code
        console.log("Error Status:", error.response.status);
        const responseCode = error.response.data.detail ? error.response.data.detail : "Unknown";
      
        setError(responseCode)
        setError(error.response.status);
      } else if (error.request) {
        // The request was made but no response was received
        console.log("No response received:", error.request);
        setError("No response from server");
      } else {
        // Something happened in setting up the request
        console.log("Error setting up request:", error.message);
        setError("Request setup error");
      }
      

    } finally {


      setLoadingForm(false);
    }
  }
  //const [vendors, setVendors] = useState(); // State to hold vendors for sidebar
  const onSubmit = async() => {
    setLoadingForm(true);
    setSuccessMessage(null);
    setError(null);

    try {
        const response = await api.post('/invite/pending/', {
          id: selectedData
        });

      if (response.status === 200) {
        setSuccessMessage('Accepting vendor success');
        fetchData()
       // fetchVendorIdSidebar(setVendors)
      } else {
        setError(response.data?.message || "Failed to accepting vendor");
      }
      
    }catch(error){
      setError(error.response?.data?.message || "Error saving data");
      console.error("Submit Error: ", error);
    } finally {
      setLoadingForm(false);
    }
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {

    fetchData()
  }, [])

  const handlePageChange = (page) => {
    if (page < 1 || page > Math.ceil(count / 5)) return; // Prevent invalid page numbers

    setCurrentPage(page);
    fetchData(page);
  };





  const columns = [
    {
      title: t("Action"),
      dataIndex: "Action",
      render: (_, record) => (

        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn btn-greys"
            data-bs-toggle="modal"
            data-bs-target="#confirmModal"
            onClick={() => setSelectedData(record.id)}
          >
            {t("Accept")}
          </button>
        </div>

      ),
      //sorter: (a, b) => a.Action.length - b.Action.length,
    },
    {
      title: `${user.type == "agency" ? t("Vendor") : t("Agency")}`,
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: t("Status"),
      dataIndex: "status",
      render: (value) => (
          <div>
              {value ?  <span className="badge badge-pill bg-success-light">{t("Accepted")}</span> :

                  <span className="badge badge-pill bg-info">Pending</span>}
             
          </div>
      ),
      sorter: (a, b) => a.Status.length - b.Status.length,
  },
    {
      title: t("Invited at"),
      dataIndex: "created_at",
      sorter: (a, b) => a.created_at.length - b.created_at.length,
    }

  ];


  const isMobileDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };

  useEffect(() => {
      const handleResize = () => {
          setScreenWidth(window.innerWidth);
      };

      // Add event listener for resizing
      window.addEventListener("resize", handleResize);

      // Cleanup event listener on component unmount
      return () => {
          window.removeEventListener("resize", handleResize);
      };
  }, []);




  return (


    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      {/*<Sidebar vendors={vendors} />*/}
<Sidebar  />
      <div className="page-wrapper">
        {(loadingForm || error) ? (
          <div style={{ textAlign: "center", margin: "10em" }}>
            {loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                  Try Again
                </button>*/}
              </div>
            )}
          </div>
        ) : (
             <>

              <div className="content container-fluid">
                {/* Page Header */}
                <div className="page-header">
                  <div className="content-page-header ">
                    <h5>{

                      user.type == "agency" ? t("Pending Vendor Invitations") : t("Pending Agency Invitations")
                    }</h5>
                    
                  </div>
                </div>
                
                {successMessage && (
                  <div className="alert alert-success">{t(successMessage)}</div>
                )}
               
                {data.length === 0 && (
                  <div className="text-center mt-5 py-5">
                    <div className="mb-4">
                      <div className="mb-3">
                        <i className="fas fa-user-clock text-muted" style={{fontSize: '4rem', opacity: 0.3}}></i>
                      </div>
                      <h4 className="text-muted mb-2">{t("No Pending Invitations")}</h4>
                      <p className="text-muted mb-4">
                        {user.type === "agency" 
                          ? t("You don't have any pending vendor invitations at the moment.")
                          : t("You don't have any pending agency invitations at the moment.")
                        }
                      </p>
                    </div>
                  </div>
                )}

            {/* /Search Filter */}
                <div className="row">
                  <div className="col-sm-12">
                    {isMobileDevice() || screenWidth <= 576 ? (
                      <>
                      {data.length > 0 ? (
                        data.map((item, index) => (
                          <div key={index} className="rounded text-secondary mb-3 text-dark">
                            <div className="w-100 p-3 rounded-top" style={{ backgroundColor: "#DAF8FD" }}>
                              <h5 className="text-dark fw-bolder mb-2">{item.name}</h5>
                            </div>
                            <div className="bg-white p-3 rounded-bottom">
                              <p style={{fontSize: "0.7rem"}} className={item.status ? "badge badge-pill bg-success-light" : "badge badge-pill bg-info"}>{item.status ? t("Accepted") : t("Pending")}</p>
                              <div className="row mt-2">
                                  <div className="col-3" style={{paddingRight: 5}}>
                                      <p style={{fontSize: "0.7rem"}}>{t("Invited at")}</p>
                                  </div>
                                  <div className="col-1 text-center">
                                      <p style={{ fontSize: "0.7rem" }}>:</p>
                                  </div>
                                  <div className="col-7">
                                      <p style={{fontSize: "0.7rem"}} className="fw-bold">{item.created_at}</p>
                                  </div>
                              </div>
                              <div className="mt-3">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#confirmModal"
                                  onClick={() => setSelectedData(item.id)}
                                >
                                  {t("Accept")}
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="p-3 rounded bg-white text-secondary mb-3">
                          <p>No Data</p>
                        </div>
                      )}

                      {/* Pagination Controls */}
                        <div className="mt-3">
                          <button
                            className="btn btn-secondary me-2"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            {t("Previous")}
                          </button>
                          <span>{t("Page")} {currentPage} {t("of")} {Math.ceil(count / 10)}</span>
                          <button
                            className="btn btn-secondary ms-2"
                            onClick={() => handlePageChange(currentPage + 1)}
                          >
                            {t("Next")}
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className=" card-table">
                        <div className="card-body vendors">
                          <div className="table-responsive table-hover table-striped">
                            <Table
                              pagination={{
                                total: count,
                                current: currentPage,
                                showTotal: (length,range) => showTotal(t,length, range),
                                itemRender:  (page, type, originalElement) => itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement),
                                onShowSizeChange: onShowSizeChange,
                              }}
                              columns={columns}
                              dataSource={data}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            
          </>
        )}

        <div className="modal fade" id="confirmModal" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{t(`Accept ${user.type == 'agency' ? 'Vendor' : 'Agency'}`)}</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>{t("Are you sure you want to accept the request?")}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {t("Cancel")}
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary ms-2"
                  onClick={onSubmit}
                  disabled={loadingForm}
                >
                    {loadingForm ? t("Submitting...") : t("Yes, Continue")}
                </button>
              </div>
            </div>
          </div>
        </div>


      </div>
      </div>
  );
};

export default InvitePending;
